import { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

// scroll bar
import 'simplebar/src/simplebar.css';

// third-party
import { Provider as ReduxProvider } from 'react-redux';

import { Amplify } from 'aws-amplify';
import awsExports from './aws-exports';

if (process.env['REACT_APP_ENV'] === 'local') {
    awsExports.aws_cloud_logic_custom[0].endpoint = 'http://localhost:9000';
}

Amplify.configure(awsExports);

// apex-chart
import 'assets/third-party/apex-chart.css';

// project import
import App from './App';
import { store } from 'store';
import reportWebVitals from './reportWebVitals';

import { NotifyProvider } from 'components/Notify/Context';
ReactDOM.render(
    <StrictMode>
        <ReduxProvider store={store}>
            <BrowserRouter basename="/">
                <NotifyProvider>
                    <App />
                </NotifyProvider>
            </BrowserRouter>
        </ReduxProvider>
    </StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
